<header class="masthead">
	<div class="navbar">
		<div class="left-header">
			<div class="workspace-title" id="create-workspace" data-toggle="dropdown">
				<div class="user-img">
					<span class="ant-avatar ant-avatar-circle ant-avatar-image ant-avatar-icon">
						<div class="email-initial-setup-owner">
							{{getInitial(workspaceName)}}
						</div>
					</span>
				</div>
				<button style="padding:8px;">
					<div class="main-title-workspace">
						{{workspaceName}}
					</div>
					<span class="drop-down-option">
						 <span class="src-components">
							 <svg *ngIf="userRole == 'Owner' || userRole == 'Admin';" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
							 <path d="M4 7L8.24264 11.2426L12.4853 7" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
							 </svg>

							 <svg *ngIf="userRole == 'Member' && workspaces.length > 1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
							 <path d="M4 7L8.24264 11.2426L12.4853 7" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
							 </svg>
						</span>
					</span>
				</button>
			</div>

			<div id="WS-dropdown" class="dropdown-menu DAM-drop-down" aria-labelledby="create-workspace">
				<div class="switch-area-section">
					<small class="text-muteds switch-workspaces">Switch Workspace</small>
					<div class="workspace-names" *ngFor="let workspace of workspaces"
					 (click)="selectWorkspace(workspace.id, workspace.title, workspace.role)">
					 <div class="user-img">
	 					<span *ngIf="workspaceName === workspace.title" class="ant-avatar-selected ant-avatar-circle ant-avatar-image ant-avatar-icon">
							<svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M1 5L4.58824 9L13 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
	 					</span>
						<span *ngIf="workspaceName != workspace.title" class="ant-avatar ant-avatar-circle ant-avatar-image ant-avatar-icon">
	 						<div class="email-initial-setup-owner">
	 							{{getInitial(workspace.title)}}
	 						</div>
	 					</span>
	 				</div>
					<div class="workspace-members-count">
						<a href="javascript:;" class="workspace-list">{{workspace.title}}</a>
						<a href="javascript:;" class="member-list" *ngIf="workspace.member === 1">{{workspace.member}} member</a>
						<a href="javascript:;" class="member-list" *ngIf="workspace.member > 1">{{workspace.member}} members</a>
					</div>
					</div>
				</div>
					<div class="text-muted font-italic px-4 py-2 text-muted" *ngIf="userRole == 'Owner' || userRole == 'Admin'">
						<button class="create-workspace-btn-disable ant-btn" *ngIf="workspaceCountAllowed == totalWorkspaceCreated" (click)="newCrafttorDummy()">
							<a>Create Workspace</a></button>
						<button class="create-workspace-btn ant-btn" *ngIf="workspaceCountAllowed != totalWorkspaceCreated" (click)="newCrafttor()">
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M12 6V18" stroke="#2D7CFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M6.3158 12H17.6842" stroke="#2D7CFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
							<a>Create Workspace</a></button>
					</div>
					<div class="" *ngIf="userRole == 'Owner' || userRole == 'Admin'">
						<div class="workspace-quota" *ngIf="workspaceCountAllowed == totalWorkspaceCreated">
							<p>Limit Reached <span class="workspace-limit-reached" (click)="showUpgradePlans()">Upgrade</span></p>
						</div>
					</div>
			</div>

			<div class="lib-icon-sec" mat-raised-button #tooltip="matTooltip"
			matTooltip="Library"
			matTooltipPosition="below"
			matTooltipClass="custom-tooltip" (click)="goToLibrary()">
				<img src="assets/img/lib-icon.svg">
			</div>

		</div>
		<form class="custom-form search-area-field" (ngSubmit)="onSubmit()" #heroForm="ngForm">
		<div class="center-header">
			<div class="search-box" id="search-box">
				<button>
					<span role="img" aria-label="search" class=""><svg viewBox="64 64 896 896" focusable="false" class="" data-icon="search" width="24px" height="24px" fill="#888888" aria-hidden="true"><path d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"></path></svg></span>
				</button>

				<div class="mat-chip-main" *ngIf="searchTerms.length > 0">
					<ul class="mat-chip-list-main">
						<li class="mat-chip-list" *ngFor="let term of searchTerms; let i = index">
							<span class="chip-txt"><a>{{ term }}</a>
								<span (click)="removeSearchTerm(i, term)" role="img" aria-label="close" tabindex="-1" class="anticon anticon-close ant-tag-close-icon">
									<svg viewBox="64 64 896 896" focusable="false" data-icon="close" width="1em" height="1em" fill="#a9a9a9" aria-hidden="true">
										<path d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z">
										</path>
									</svg>
								</span>
							</span>
						</li>
					</ul>
				</div>

				<input type="text" placeholder="Type here to search by title, tags..." class="text-field" name="searchText" [(ngModel)]="searchText"/>
				<input style="display: none" type="Submit" value="Search" class="button">
			</div>
		</div>
		</form>
		<div class="right-header">
			<div class="menu-pop-over anticon-bell">
				<a href="javascript:;" class="upgrade-txt" (click)="showUpgradePlans()" *ngIf="userRole == 'Owner' || userRole == 'Admin'">Upgrade</a>


				<!-- <button id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
					<span role="img" aria-label="bell" class="">Upgrade</span>
				</button> -->
				<!-- <div class="dropdown-menu" aria-labelledby="notification-pop-over">
						<div class="dropdown-container">
							<div class="item">No new Notification</div>
					</div>
				</div> -->
			</div>

			<div class="figma-icons-section">
        <div class="plugin-figma-icon">
          <button (click)="openFigma()" id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
            <img src="assets/img/ic-figma.png">
          </button>
        </div>

        <div class="plugin-sketch-icon">
          <button (click)="openSketch()" id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
            <img src="assets/img/ic-sketch.png">
          </button>
        </div>

        <div class="plugin-ai-icon">
          <button (click)="openIllustrator()" id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon">
            <img src="assets/img/ai.png" style="width: 20px; height: 20px;">
          </button>
        </div>
      </div>

			<div class="menu-pop-over anticon-bell">
				<button id="notification-pop-over" data-toggle="dropdown" class="anticon-bell-icon" (click)="getNotifications()">
					<img src="assets/img/ic-noti.svg">
				</button>
				<!-- <span class="dot"></span> -->
				<div class="dropdown-menu notification-area" aria-labelledby="notification-pop-over">
						<div class="dropdown-container">
							<h5 class="notification-txt" style="margin-bottom:20px;"><b>Notifications</b></h5>
							<div class="notification-item">

								<!-- <div class="" *ngIf="showLoader">
									<img src="assets/img/loader.svg" style="margin-left: auto;margin-right: auto;display: block;width: 30%;" alt="">
								</div> -->

								<div *ngIf="notifications.length == 0" class="empty-notification-area">
									<img src="assets/img/no-noti.svg" alt="">
									<span>You have no notifications</span>
								</div>


								<ul *ngFor="let noti of notifications" style="padding: 0px;">
									<li style="border-bottom: 1px solid rgba(0,0,0,0.1);padding: 16px 0 16px 0;margin: 0 16px;">
										<div class="user-details-info">
										<div class="user-img">
											<span class="ant-avatar ant-avatar-circle ant-avatar-image ant-avatar-icon" style="width: 40px; height: 40px; line-height: 40px; font-size:18px; font-weight: 500;">
												<div class="email-initial-setup" [style.background-color]="getRandomColor()">
													{{getName(noti.firstName)}}{{getName(noti.lastName)}}
												</div>
											</span>
										</div>
											<div>
												<div class="user-info-name">
													<span>{{noti.message}} <b>{{noti.firstName}} {{noti.lastName}}</b></span>
												</div>
												<div class="" style="margin-top: 4px;">
													<span class="notification-date">{{noti.timestamp.toString().split(".")[0]}}</span>
												</div>
											</div>
										</div>
									</li>
								</ul>
							</div>
					</div>
				</div>
			</div>


			<div class="menu-pop-over user-name" *ngIf="currentUser  && !mobileView">
				<button id="user-pop-over" data-toggle="dropdown" class="user-icon-btn">
					<img *ngIf="!userPic" src="assets/img/user-profile.svg">
					<img *ngIf="userPic" src="{{userPic}}">
				</button>
				<div class="dropdown-menu" aria-labelledby="user-pop-over">
					<div class="dropdown-container">
						<div class="upper-container">
							<div class="name-pro">
								<h6>{{currentUser.firstName+" "+currentUser.lastName}}</h6>
								<span class="pro">
									{{planName}}
								</span>
								<!-- <span class="pro">
									BETA
								</span> -->
							</div>
							<div class="email">{{currentUser.email}}</div>
							<div *ngIf="totalSpaceAllowed <= 1000 && consumedSpaceAllowed <= 1000" class="storage-size">{{consumedSpaceAllowed | number: '1.2-2'}}MB / {{totalSpaceAllowed}}GB</div>
              <div *ngIf="totalSpaceAllowed <= 1000 && consumedSpaceAllowed > 1000" class="storage-size">{{consumedSpaceAllowed/1000 | number: '1.2-2'}}GB / {{totalSpaceAllowed}}GB</div>
							<div *ngIf="totalSpaceAllowed > 1000 && consumedSpaceAllowed > 1000" class="storage-size">{{consumedSpaceAllowed/1000 | number: '1.2-2'}}GB / {{totalSpaceAllowed/1000}}TB</div>
							<!-- <div class="storage-indicator">
								<div class="storage-indicator-color">

								</div>
							</div> -->
							<progress id="file" value="{{consumedSpaceAllowed}}" max="{{totalSpaceAllowedProgress}}"></progress>
						</div>

						<ul class="dropdown-list list-group">
							<div class="hr-line"></div>
							<a routerLink="/my-profile"><li class="list-group-item">My profile</li></a>
							<a (click)="personalClick()"><li class="list-group-item">My content hub</li></a>
							<div class="hr-line"></div>
							<a routerLink="/how-it-works" target="_blank"><li class="list-group-item">How it works</li></a>
							<a routerLink="/home" target="_blank"><li class="list-group-item">Go to Homepage</li></a>
							<a (click)="goToMarketplace()"><li class="list-group-item">Go to Marketplace</li></a>
							<a (click)="goToFeedback()"><li class="list-group-item">Feedback & bugs report</li></a>
							<a routerLink="/faq" target="_blank"><li class="list-group-item">FAQ</li></a>
							<a (click)="goProClick()" *ngIf="planName == 'Free'">
								<li class="list-group-item" style="background-color: var(--primaryColorLightBlue); border-radius: 4px; margin-top: 8px; display: block;"><b style="color: #2d7cff">Upgrade plan:</b><span> You're on the free plan. Upgrade now for unlimited storage, access, members, and more.</span></li>
							</a>
						</ul>
						<div class="logout-btn">
							<button type="button" class="ant-btn" (click)="logOut()"><a>Logout</a></button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</header>

<section *ngIf="videosViewSection">
	<div class="main-container">
		<div class="side-bar hide-sidebar" id="side-bar">
			<div class="left-sticky-bar" id="left-sticky-bar">
				<form class="custom-form search-area-field" (ngSubmit)="onSubmit()" #heroForm="ngForm">
					<div class="side-search-box">
						<div class="search-box-side-bar" id="search-box" style="box-shadow:none">
							<button>
								<span role="img" aria-label="search" class=""><svg viewBox="64 64 896 896" focusable="false" class="" data-icon="search" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"></path></svg></span>
							</button>
							<input type="" name="searchText" placeholder="Search" [(ngModel)]="searchText">
							<input style="display: none" type="Submit" value="Search" class="button">
						</div>
					</div>
				</form>
				<div class="side-bar-list-container">
					<div class="sidebar-list-group">
						<a class="" (click)="mainClick()"><span role="img" aria-label="appstore" class="anticon anticon-appstore">
							<img src="assets/img/all-boards.svg" alt="">
						</span>All Boards</a>

						<a class="" (click)="peopleClick()"><span role="img" aria-label="appstore" class="anticon anticon-appstore">
							<img src="assets/img/people.svg" alt="">
						</span>People</a>

					</div>
					<div class="sidebar-list-group">
						<div class="add-boards">
							<h5>BOARDS</h5>
							<button *ngIf="showLoaderBoardsList"><span role="img" aria-label="plus-circle" class="anticon anticon-plus-circle">
								<img class="img-up-loader-boards" src="assets/img/img-up.svg" alt="">
							</span></button>

							<button (click)="newBoardClick()" mat-raised-button #tooltip="matTooltip"
		        	matTooltip="Create new board"
		        	matTooltipPosition="above"
							matTooltipClass="custom-tooltip"><span role="img" aria-label="plus-circle" class="anticon anticon-plus-circle">
								<img src="assets/img/create-board.svg" alt="">
							</span></button>
						</div>
						<ul class="list-group main-boards-list">
							<li *ngFor="let board of boards; let i = index" [ngClass]="{'selected-color' : i==selectedIndex}" class="boards-list-data">
								<a (click)="boardlistClick(board.title, board.id); changeColors(i)">{{ board.title }}
									<img src="assets/img/pin-fill.svg" *ngIf="board.is_pin == true">
									<button class="new-board-asset" *ngIf="board.status != ''"><strong>{{ board.status }}</strong></button>
									<button *ngIf="userRole == 'Member' && board.verified == false" class="new-3d">Unverified</button>
								</a>
								<button class="board-option delete-edit-btn" data-toggle="dropdown">
									<svg viewBox="64 64 896 896" focusable="false" class="" data-icon="ellipsis" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z"></path></svg>
								</button>
								<div class="dropdown-menu border-shadow border-radius-5">
									<ul class="list-group border-radius-5">
										<li class="board-list-option" (click)="pinBoard(board.id)" *ngIf="board.is_pin == false">
											<img class="pin-board" src="assets/img/pin-board-black.svg" alt="">
											<a class="text dropdown-txt" href="javscript:;">Pin</a></li>
										<li class="board-list-option" (click)="unPinBoard(board.id)" *ngIf="board.is_pin == true">
											<img class="pin-board" src="assets/img/pin-board-black.svg" alt="">
											<a class="text dropdown-txt" href="javscript:;">Unpin</a></li>
										<li class="board-list-option" (click)="shareBoard()">
											<img src="assets/img/share-black.svg" alt="" style="margin-right: 8px;">
											<a class="text dropdown-txt" href="javscript:;">Share</a></li>

										<li class="board-list-option" (click)="openEditBoardNames(board.id, board.title)">
											<img style="width: 22px;" class="pin-board" src="assets/img/edit-icon.svg" alt="">
											<a class="text" href="javscript:;">Rename</a>
										</li>

										<hr class="more-options-hr">

										<li class="board-list-option" *ngIf="userRole == 'Member' && board.verified == false" (click)="verifyBoard(board.id)">
											<img style="margin-right: 7px; margin-left: -5px;" src="assets/img/verify-black.svg" alt="">
											<a class="text dropdown-txt" href="javscript:;">Verify</a>
										</li>

										<li class="board-list-option" (click)="openDeleteBoardShare(board.id, board.title)">
											<img src="assets/img/delete-red.svg" alt="" style="margin-right: 8px;">
											<a class="text-danger" href="javscript:;">Delete</a>
										</li>
									</ul>
								</div>
							</li>
						</ul>
					</div>

					<hr style="width: 90%; margin-left: 0;">

					<div class="inbox-settings">

					<div class="sidebar-list-group inbox-areas" *ngIf="userRole == 'Owner' || userRole == 'Admin'">
						<a (click)="inboxClick()" class="sidebar-muted">
							<span role="img" aria-label="delete" class="anticon anticon-delete"><img src="assets/img/inbox.svg" alt="">
						</span>Inbox</a>
					</div>

					<div class="sidebar-list-group inbox-areas" *ngIf="userRole == 'Owner' || userRole == 'Admin'">
						<a (click)="settingsClick()" class="sidebar-muted"><span role="img" aria-label="delete" class="anticon anticon-delete">
							<img src="assets/img/settings.svg" alt="">
						</span>Settings
									</a>
							</div>
							<div class="sidebar-list-group settings-areas" *ngIf="userRole == 'Owner' || userRole == 'Admin'">
								<a (click)="archiveClick()" class="sidebar-muted" id="trash-txt"><span role="img" aria-label="delete" class="anticon anticon-delete">
									<img src="assets/img/red-delete-24.svg" alt="">
								</span>Trash
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="center-container">
			<div>
				<div class="homepage-heading">
					<div class="homepage-heading_">
					<div class="homepage-heading-title">
						<h2>Videos Tutorial Kit</h2>
						<!-- <span class="user-illus-count">Assets</span> -->
					</div>

					<div class="ant-select ant-select-borderless ant-select-single ant-select-show-arrow home-switch-view-select d-flex">

						<div style="flex-grow: 1;"></div>
					</div>
					</div>
				</div>

        <div class="illus-rollup-view row mb-5 mt-2">

          <div class="video-container">
						<div class="video-ui">
							<iframe src="https://www.youtube.com/embed/1EbHNKLxwzk"
	                    frameborder="0"
	                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
	                    allowfullscreen>
	            </iframe>

							<h6>Welcome to Crafttor</h6>
							<p>Introduction to Crafttor Workspace & how to use and organise your workspace.</p>

							<div class="view-eye">
								<img style="width:20px;" src="assets/img/view-eye.svg" alt="">
								<span>34 views</span>
							</div>
						</div>

						<div class="video-ui">
							<iframe src="https://www.youtube.com/embed/pZFZWKgwE00"
	                    frameborder="0"
	                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
	                    allowfullscreen>
	            </iframe>

							<h6>Show E-commerce UI Design</h6>
							<p>Check how you can design an e-commerce products showcase with Crafttor's plugin.</p>

							<div class="view-eye">
								<img style="width:20px;" src="assets/img/view-eye.svg" alt="">
								<span>12 views</span>
							</div>
						</div>

						<div class="video-ui">
							<iframe src="https://www.youtube.com/embed/Xv_4v_CXk4g"
	                    frameborder="0"
	                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
	                    allowfullscreen>
	            </iframe>

							<h6>Kaleidoscope: by Crafttor</h6>
							<p>Extract a new Ui pattern from an current pattern and user it to design products or product backgrounds.</p>

							<div class="view-eye">
								<img style="width:20px;" src="assets/img/view-eye.svg" alt="">
								<span>32 views</span>
							</div>
						</div>

						<div class="video-ui">
							<iframe src="https://www.youtube.com/embed/knxJinqWzqU"
	                    frameborder="0"
	                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
	                    allowfullscreen>
	            </iframe>

							<h6>Download Formats</h6>
							<p>Here users can find how they can download different formats of their assets.</p>

							<div class="view-eye">
								<img style="width:20px;" src="assets/img/view-eye.svg" alt="">
								<span>14 views</span>
							</div>
						</div>

          </div>
        </div>


			<div class="loader-scenarios" *ngIf="showTopRightLoader">
				<img class="img-up-loader" style="width: 30px;" src="assets/img/img-up.svg" alt="">
			</div>

			<div class="loader-scenarios-success-msgs" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="200" *ngIf="sendSuccessful">
				<span class="ant-avatar-selected">
					<svg width="18" height="14" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M1 5L4.58824 9L13 1" stroke="#0fa636" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
				</span>
				<p>{{successfullMessage}}</p>
			</div>

			<div class="loader-scenarios-error-msgs" data-aos="fade-left" data-aos-easing="linear" data-aos-duration="200" *ngIf="sendSuccessfulErrorMsg">
				<p>{{sendSuccessfulErrorMessage}}</p>
			</div>

			<div *ngIf="showLeaveLoader" class="">
				<div class="total-img-count center moved-success-area-loader">
					<img src="assets/img/green-loader.gif" alt="" style="height: 25px;">
				</div>
			</div>
			</div>
		</div>
	</div>
</section>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
	padding-top: 120px;"
	class="modal"
	tabindex="-1"
	role="dialog"
	[ngStyle]="{'display':shareLinkStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="position: relative; padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
			<div class="modal-body">
			<button type="button" class="close" (click)="closeShareLinkStyle()" data-dismiss="modal" aria-label="Close">
				<img src="assets/img/cross.svg" alt="download free illustrations">
			</button>
			<div class="img-container-modal">
			   <img src={{shareImageLink}}>
			</div>
			<div class="mt-2 share-class-permit">
				<h3 class="share-a-link">Share a link</h3>
				<hr>

				<div class="main-permit-sec">
					<div class="allow-download-sec">
						<div data-toggle="dropdown">
							<h5>Allow downloads <img src="assets/img/tool-tip.svg" alt="" mat-raised-button #tooltip="matTooltip"
		        	matTooltip="Assets can be downloaded by users with whom you share it."
		        	matTooltipPosition="above"
							matTooltipClass="custom-tooltip"></h5>
							<p class="dropdown-menu allow-download-info">Assets can be downloaded by users with whom you share it.</p>
	          </div>
						<div class="allow-checkbox">
							<label *ngIf="planName != 'Free'" class="switch-share-settings" [(ngModel)]="allowDownloadSelected" (change)="allowDownload()">
								<input type="checkbox" checked>
								<span class="slider round"></span>
							</label>

							<p class="go-pro" *ngIf="planName == 'Free'" routerLink="/dam/subscription">Go pro</p>
						</div>
					</div>

					<div class="allow-download-sec">
						<h5>Expire link</h5>
						<div class="allow-checkbox">
							<select *ngIf="planName != 'Free'" (change)="selectExpireLink($event)" class=" input-md" id="expireLink">
								<option value="f">Never</option>
								<option value="d">1 day</option>
								<option value="w">1 week</option>
								<option value="m">1 month</option>
							</select>

							<p class="go-pro" *ngIf="planName == 'Free'" routerLink="/dam/subscription">Go pro</p>
						</div>
					</div>

					<!-- <div class="allow-download-sec">
						<h5>Show comments</h5>
						<div class="allow-checkbox">
							<label class="switch-share-settings" [(ngModel)]="showCommentSelected" (click)="allowShowComments()">
								<input type="checkbox" checked>
								<span class="slider round"></span>
							</label>
						</div>
					</div>

					<div class="allow-download-sec">
						<h5>Allow commenting</h5>
						<div class="allow-checkbox">
							<label class="switch-share-settings" [(ngModel)]="allowCommentingSelected" (click)="allowCommenting()">
								<input type="checkbox" checked>
								<span class="slider round"></span>
							</label>
						</div>
					</div> -->
				</div>
				<div class="d-flex email-input-share-link mt-3" *ngIf="isHideShareLinkGenerated" (click)="showGeneratedLink()">
					<div class="text-muted no-sharable">No shareable link</div>
					<button class="button create-share-link">Create Link</button>
				</div>
				<div class="d-flex email-input-share-link mt-3" *ngIf="isShowShareLinkGenerated">
					<div class="share-link-field">
						<input type="" name="" value="{{shareableLink}}" class="" placeholder="Generated Link" #copysharelink>
					</div>
					<button class="create-share-link" (click)="copyShareLink(copysharelink)">Copy</button>
				</div>
				<div class="no-account-txt">
					<p>Anyone can view. No account required.</p>
					<div class="link-copied" *ngIf="showLinkCopied">
						<p>Copied to clipboard</p>
					</div>
				</div>
			</div>
			</div>
		</div>
	</div>
</div>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
	padding-top: 200px;"
	class="modal"
	tabindex="-1"
	role="dialog"
	[ngStyle]="{'display':boardRenameStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="position: relative; padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
		<div class="modal-body">
		<button type="button" class="close" (click)="closeEditBoardNames()" data-dismiss="modal" aria-label="Close">
			<img src="assets/img/cross.svg">
		</button>
		<div class="img-container-modal">
		   <img src={{renameImageLink}}>
		</div>
		<div class="mt-2 share-class-permit">
			<h3 class="share-a-link">Rename board</h3>
			<div class="d-flex email-input-share-link mt-3">
				<div class="rename-link-field">
					<input type="" name="" value="{{boardCurrentName}}" class="" placeholder="Board name" [(ngModel)]="boardNewName">
				</div>
			</div>
			<p>{{renameErrorMsg}}</p>
			<div class="rename-save-btn">
				<button class="button cancel-button" (click)="closeEditBoardNames()">Cancel</button>
				<button *ngIf="!showRenameLoader" class="button create-rename-link" (click)="editBoardNamesApi()">Save</button>
				<button *ngIf="showRenameLoader" class="button create-rename-link"><img style="height: 18px;" src="assets/img/img-up-white.svg"></button>
			</div>
		</div>
		</div>
	</div>
</div>
</div>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
	padding-top: 150px;"
	class="modal"
	tabindex="-1"
	role="dialog"
	[ngStyle]="{'display':createWorkspaceStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="position: relative; padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
			<div class="modal-body new-create-workspace-dialog">
				<button style="margin: -10px;" type="button" class="close" (click)="closeNewWorkspaceDialog()" data-dismiss="modal" aria-label="Close">
					<img src="assets/img/cross.svg">
				</button>
				<div class="mt-2 share-class-permit">
					<div class="inner-content welcome-txt" style="background-color: #fff">
						<h6>Create Workspace</h6>
						<p class="create-space-p">Create and customise a workspace as per your requirements.</p>
						<div class="create-workspace-txt">
							<p>Name Workspace</p>
						</div>
						<div class="btn-wrapper">
							<form style="width: 100%" class="form-horizontal" [formGroup]="creatwWorkspace" (ngSubmit)="createWorkspace(workspaceNames.value)">
								<input maxlength="50" formControlName="message" placeholder="Your workspace name" data-test-name="invite-email-input" class="workspace-ant-input-invite-field" type="text" value="" #workspaceNames>
							</form>
						</div>
						<span class="text-danger error-text board-error-text" *ngIf="isShowCreateWorkspaceError">{{createWorkspaceErrorMessage}}</span>
						<span class="text-danger error-text board-error-text" *ngIf="isShowCreateLoginWorkspaceError" style="cursor: pointer;"><b>{{createWorkspaceLoginErrorMessage}}</b></span>
						<button *ngIf="!showLeaveLoader" style="width: 100%" [disabled]="workspaceNames.value === ''" data-test-name="send-invite-button" type="button" class="ant-btn-create-org ant-btn-default ant-input-search-button" (click)="createWorkspace(workspaceNames.value)"><span role="img" aria-label="plus" class="create-workspace-span">Create Workspace</span></button>

						<button *ngIf="showLeaveLoader" style="width: 100%" data-test-name="send-invite-button" type="button" class="ant-btn-create-org ant-btn-default ant-input-search-button">
							<img class="img-up-loader" style="height: 18px;" src="assets/img/img-up-white.svg" alt="">
						</button>

						<button type="button" name="button" class="new-workspace-cancel" (click)="closeNewWorkspaceDialog()">Cancel</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
